import styled from 'styled-components';

import { Body } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Tabs as CogsTabs } from '@cognite/cogs-core-v11/components/tabs/tabs.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const ConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px;
`;

export const TabPane = styled(CogsTabs.Tab)`
  padding: 8px;
`;

export const TabPanelWrapper = styled.div`
  height: 100%;
  overflow: auto;
  margin-top: 8px;
`;

export const TitleContainer = styled(Flex).attrs({
  alignItems: 'center',
})`
  height: 100%;
  padding: 0px 16px;
`;

export const PermissionInfoContainer = styled(Flex).attrs({
  alignItems: 'center',
})`
  height: 100%;
  padding: 0px 16px;
`;

export const NotPermittedText = styled(Body).attrs({ size: 'x-small' })`
  color: ${({ theme }) => theme['text-icon--status-critical']};
`;

export const PermittedText = styled(Body).attrs({ size: 'x-small' })`
  color: ${({ theme }) => theme['text-icon--status-success']};
`;

export const FixedWidthButton = styled(Button)`
  width: 200px;
`;
